import angular from 'angular';
import { AssetsExplorerModel, CurrentUser, DisplayNames } from 'Roblox';
import inventoryModule from '../inventoryModule.js';

function inventoryContentController(
  $httpParamSerializer,
  $q,
  $scope,
  $log,
  assetsConstants,
  assetsService,
  $document,
  recommendationsConstants,
  cursorPaginationServiceV2,
  cursorPaginationConstants,
  inventoryService
) {
  'ngInject';

  const ctrl = this;

  ctrl.pageType = 'inventory';
  ctrl.assets = [];

  ctrl.cursorPager = cursorPaginationServiceV2.createPager({
    pageSize: 30,
    loadPageSize: 100,
    getItems(pagingParameters) {
      return inventoryService.getInventoryItems(pagingParameters);
    }
  });

  const pageLoaded = function (items) {
    ctrl.assets = items;
    ctrl.currentData.templateVisible = true;
  };

  const pageLoadError = function (e) {
    if (e.type === cursorPaginationConstants.errorType.pagingParametersChanged) {
      // User switched to another tab. Do nothing.
      return;
    }

    // This page does nothing with errors right now.
    $log.error(e);
  };

  ctrl.assetsPager = {
    loadNextPage() {
      if (!ctrl.cursorPager.canLoadNextPage()) {
        return;
      }

      ctrl.cursorPager.loadNextPage().then(pageLoaded).catch(pageLoadError);
    },
    loadPreviousPage() {
      if (!this.canLoadPreviousPage()) {
        return;
      }

      ctrl.cursorPager.loadPreviousPage().then(pageLoaded).catch(pageLoadError);
    },
    canLoadNextPage: ctrl.cursorPager.canLoadNextPage,
    canLoadPreviousPage: ctrl.cursorPager.canLoadPreviousPage,
    getCurrentPageNumber: ctrl.cursorPager.getCurrentPageNumber
  };

  const isPrivateServerCategoryType = function (category) {
    return category.categoryType === assetsConstants.types.privateServers;
  };

  $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
    ctrl.currentData.templateVisible = false;

    const { category } = toState;
    const { subcategory } = toState;
    ctrl.currentData.category = category;
    ctrl.currentData.subcategory = subcategory;
    ctrl.currentData.AssetTypeId = subcategory.id;
    ctrl.currentData.isPrivateServerCategoryType = isPrivateServerCategoryType(category);

    ctrl.constructCatalogUrl();
    // Remove behind switch in AVBURST-564
    $document.triggerHandler('Roblox.Recommendations.GetItems', [
      ctrl.currentData.AssetTypeId,
      ctrl.currentData.category.name
    ]);

    ctrl.cursorPager
      .setPagingParametersAndLoadFirstPage({
        cursor: '',
        userId: ctrl.userId,
        placeTab: subcategory.filter,
        assetTypeId: subcategory.id
      })
      .then(pageLoaded)
      .catch(pageLoadError);
  });

  ctrl.isRecommendationAvailable = function () {
    return ctrl.recommendationsType >= 0 && ctrl.currentData.AssetTypeId > 0;
  };

  ctrl.constructCatalogUrl = function () {
    const itemSection = assetsService.getItemSection(ctrl.currentData.category);
    let urlParams = {};
    if (
      angular.isDefined(ctrl.assetToCategoryMappings) &&
      angular.isDefined(ctrl.assetToSubcategoryMappings)
    ) {
      if (itemSection === assetsConstants.library) {
        ctrl.currentData.assetTypeUrl = ctrl.staticData.absoluteLibraryUrl;
        urlParams = {
          Category: ctrl.assetToCategoryMappings[ctrl.currentData.AssetTypeId],
          CatalogContext: assetsConstants.currentCatalogContext
        };
        ctrl.currentData.assetTypeUrl += `?${$httpParamSerializer(urlParams)}`;
        ctrl.currentData.itemSection = assetsConstants.library;
      } else if (itemSection === assetsConstants.catalog) {
        ctrl.currentData.assetTypeUrl = ctrl.staticData.absoluteCatalogUrl;

        urlParams = {
          Category: ctrl.assetToCategoryMappings[ctrl.currentData.AssetTypeId],
          Subcategory: ctrl.assetToSubcategoryMappings[ctrl.currentData.subcategory.id]
        };
        ctrl.currentData.assetTypeUrl += `?${$httpParamSerializer(urlParams)}`;
        ctrl.currentData.itemSection = assetsConstants.catalog;
      } else {
        ctrl.currentData.itemSection = null;
      }
    }
  };

  const init = function () {
    ctrl.showCreatorName = true;
    ctrl.staticData = AssetsExplorerModel;
    ctrl.isOwnInventory = Number(CurrentUser.userId) === ctrl.userId;
    ctrl.recommendationsType = recommendationsConstants.recommendationTypes.asset; // TODO: we need to pull this into separated file from core script instead of cross other project because there is no way to tell there is change there
    ctrl.nameForTitle = DisplayNames?.Enabled() ? ctrl.displayName : ctrl.username;

    ctrl.currentData = {
      currentPage: 1,
      totalPages: 1,
      category: null,
      subcategory: null,
      assetTypeUrl: ctrl.staticData.absoluteCatalogUrl,
      ItemTypeId: 0, // No bundles
      AssetTypeId: 0,
      itemSection: assetsConstants.types.catalog,
      templateVisible: true,
      isRecommendationAvailable: false
    };

    const catalogMappingPromises = [];
    catalogMappingPromises.push(assetsService.getAssetToCategoryMappings());
    catalogMappingPromises.push(assetsService.getAssetToSubcategoryMappings());

    $q.all(catalogMappingPromises).then(function (results) {
      ctrl.assetToCategoryMappings = results[0];
      ctrl.assetToSubcategoryMappings = results[1];
      ctrl.constructCatalogUrl();
    });
  };

  ctrl.$onInit = init;
}

inventoryModule.controller('inventoryContentController', inventoryContentController);
export default inventoryContentController;
